import { getDefaultExportFromCjs as s } from "./main9.js";
import { _ as a } from "./main11.js";
var o = a;
function f(t, r, e) {
  return t == null ? t : o(t, r, e);
}
var m = f;
const l = /* @__PURE__ */ s(m);
export {
  l as default
};
